/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Filter for retrieving only symbols that continue across multiple reels. */
@cc._decorator.ccclass
export default class ContinuousReelStreakFilter extends StreakTrackerFilterBase
{
    /** Minimum symbols to count as streka. */
    @property({ type: cc.Integer, visible: true })
    private _minStreak: number = 2;
    /** Public accessor to min symbols. */
    public set MinStreak(value: number) { this._minStreak = value; }

    /** Valid reels, if empty all reels valid. */
    @property({ type: [cc.Integer], visible: true })
    private _validReels: number[] = [];

    /** If true, allows streaks that do start at first reel. */
    @property({ visible: true })
    private _allowSubStreak: boolean = false;
    public set AllowSubStreak(value: boolean) { this._allowSubStreak = value; }

    /** Filters out symbols that are not on min number of reels. */
    public Filter = (symbols: ISymbolData[]) =>
    {
        let reelIndexes: number[] = [];
        let streakReelIndexes: number[] = [];

        let applyValidReelFilter: boolean = this._validReels.length > 0;

        symbols.forEach(x =>
        {
            // Unique list
            if (reelIndexes.indexOf(x.ReelIndex) < 0
                && (!applyValidReelFilter || this._validReels.indexOf(x.ReelIndex) > -1))
            {
                reelIndexes.push(x.ReelIndex);
            }
        }, this);

        let streakCount: number = 1;

        reelIndexes = reelIndexes.sort((a, b) => a - b);

        reelIndexes.forEach((reelIndex, index) =>
        {
            // Not a streak
            if (reelIndexes[index - 1] + 1 !== reelIndex)
            {
                // One missed symbol and it's over
                if (index > 0 && !this._allowSubStreak)
                {
                    return [];
                }
            }
            else // Is part of a streak
            {
                streakCount++;
                if (streakCount >= this._minStreak)
                {
                    streakReelIndexes.push(reelIndex);

                    // Add the previous streak members
                    if (streakCount > 1 && streakCount === this._minStreak)
                    {
                        for (let i: number = 1; i < streakCount; i++)
                        {
                            streakReelIndexes.push(reelIndex - i);
                        }
                    }
                }
            }
        }, this);

        // Return those within the valid reelIndexes.
        return symbols.filter(x => streakReelIndexes.indexOf(x.ReelIndex) !== -1);
    }
}
